/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CancelPatientDialog.vue?vue&type=template&id=6f2a51c2"
import script from "./CancelPatientDialog.vue?vue&type=script&lang=js"
export * from "./CancelPatientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2a51c2')) {
      api.createRecord('6f2a51c2', component.options)
    } else {
      api.reload('6f2a51c2', component.options)
    }
    module.hot.accept("./CancelPatientDialog.vue?vue&type=template&id=6f2a51c2", function () {
      api.rerender('6f2a51c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/CancelPatientDialog.vue"
export default component.exports